module.exports = __webpack_public_path__ + "static/Vernissage_Marlene_Lipski_8.3.20-e614e4dc3f6131d19dcfa1a024e1775f.pdf";